module.exports = __webpack_public_path__ + "images/help/avatars/maklu-409e63b6aa6374f45ae68ec01b01c470.jpg";